// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__CyObe","mainContent":"Layout_mainContent__19qWa"};